module.exports = __webpack_public_path__ + "img/COMPEGENCE_logo-compressed.0e18cc6c.jpeg";